import React from 'react';
import { useDispatch } from "react-redux";

import { setAdminMode } from 'src/actions/organisationActions';

const AdminMode = () => {
  const dispatch = useDispatch();
  const [searchOpen, setSearchOpen] = React.useState(false);

  const handleKeyboard = ({ repeat, metaKey, ctrlKey, key }) => {
    if (repeat) return

    // Handle both, `ctrl` and `meta`.
    if ((metaKey || ctrlKey) && key === 'a') setSearchOpen(prev => !prev)
  }

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyboard)

    // Important to remove the listeners.
    return () => document.removeEventListener('keydown', handleKeyboard)
  })

  React.useEffect(() => {
    dispatch(setAdminMode(searchOpen));
  }, [searchOpen]);

  return (
    <React.Fragment />
  )
};

export default AdminMode;